export default __webpack_public_path__ + "media/application/assets/images/signing-instructions/CA-db9d0a99d17fe424fb7d147d5c466f19.PNG";